import AverageByIngredientsList from './AverageByIngredientsList'

export default {
  list: AverageByIngredientsList,
}
